import { render } from "./LightboxProductsRevenue.vue?vue&type=template&id=407f73ed"
import script from "./LightboxProductsRevenue.vue?vue&type=script&lang=js"
export * from "./LightboxProductsRevenue.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__